/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendProjectInvitationDTO
 */
export interface ResendProjectInvitationDTO {
    /**
     * 
     * @type {string}
     * @memberof ResendProjectInvitationDTO
     */
    projectIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof ResendProjectInvitationDTO
     */
    inviteeEmail: string;
}

/**
 * Check if a given object implements the ResendProjectInvitationDTO interface.
 */
export function instanceOfResendProjectInvitationDTO(value: object): value is ResendProjectInvitationDTO {
    if (!('projectIdentifier' in value) || value['projectIdentifier'] === undefined) return false;
    if (!('inviteeEmail' in value) || value['inviteeEmail'] === undefined) return false;
    return true;
}

export function ResendProjectInvitationDTOFromJSON(json: any): ResendProjectInvitationDTO {
    return ResendProjectInvitationDTOFromJSONTyped(json, false);
}

export function ResendProjectInvitationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendProjectInvitationDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'projectIdentifier': json['projectIdentifier'],
        'inviteeEmail': json['inviteeEmail'],
    };
}

export function ResendProjectInvitationDTOToJSON(value?: ResendProjectInvitationDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectIdentifier': value['projectIdentifier'],
        'inviteeEmail': value['inviteeEmail'],
    };
}

